<template>
  <v-container fluid>
    <v-row align="center" justify="space-between" class="dddark rounded mb-5 infocontainer" style="margin-top: -10px;" v-show="noDataAvailable">
      <v-col cols="12">
        <span class="d-block pb-1 text-h6 text-center">{{ $t('components.AppointmentsDashboard.NoAppointments') }}</span>
      </v-col>
    </v-row>

    <v-row align="start" justify="space-between" class="dddark rounded" style="margin-top: -10px;">
      <v-col cols="auto">
        <span class="d-block pb-1 text-h6">{{ $t('components.AppointmentsDashboard.Title') }}</span>
      </v-col>
    </v-row>

    <v-row id="appointments_report" class="ddblack">
      <AppointmentsWidgets :data="statistics" :loading="loading"/>
      <v-col cols="12">
        <AppointmentsStats :initial-data="statistics.appointments_stats" :loading="loading" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DataAPI from '@/utils/DataAPI';

import AppointmentsWidgets from "@/components/dashboard/appointments/AppointmentsWidgets.vue";
import AppointmentsStats from "@/components/dashboard/appointments/AppointmentsStats.vue";

/**
 * This component includes all the features of Dashboard page such as change
 * between clinics, dates, download the report and show all other dashboard
 * widgets.
 *
 * To get data from the backend it uses the class DataAPI. To ensure that the
 * user is logged and check its capabilities it uses the class AuthAPI.
 */

export default {
  name: 'AppointmentsDashboard',
  props: {
    initialClinic: {
      type: String,
      default: ""
    },
    locationId: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    loading: true,
    noDataAvailable: false,
    clinic: "",
    statistics: {
      total_appointments: 0,
      booked_appointments: 0,
      showed_appointments: 0,
      noshow_appointments: 0,
      cancelled_appointments: 0,
      deleted_appointments: 0,
      confirmed_appointments: 0,
      appointment_stats: {}
    },
    isMobile: false
  }),
  watch: {
    locationId(newKey) {
      this.updateData(newKey);
    },
  },
  async mounted() {
    this.onResize();
    window.addEventListener('resize', this.onResize);
    await this.updateData(this.initialClinic, this.locationId);
  },
  methods: {
    noAppointmentsDataAvailable() {
      return this.statistics.total_appointments === 0
    },
    async updateData(clinic = false, locationId = false) {
      this.loading = true;
      this.statistics = await DataAPI.getAppointmentsData({ clinic, locationId });
      if (this.noAppointmentsDataAvailable()) this.noDataAvailable = true;
      this.loading = false;
    },
    onResize() {
      this.isMobile = window.innerWidth < 1000;
    }
  },
  components: {
    AppointmentsWidgets,
    AppointmentsStats
  }
}
</script>

<style scoped>
.infocontainer {
  background-color: var(--v-ddlightblue-base) !important;
}
</style>